import { render, staticRenderFns } from "./empty-star.vue?vue&type=template&id=1de579b1&functional=true"
import script from "./empty-star.vue?vue&type=script&lang=js"
export * from "./empty-star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports